import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PrerenderReady from '../PrerenderReady';
import { getToken, api } from '../gap-mvp/api';
import { useLang } from '../../contexts/LangContext';
import PublicToggleBar from '../PublicToggleBar';

// Cennik Gap Assessment by MQS (10.08) - liczby zatwierdzone przez Marcina wprost w artefakcie
// (Starter ~490 zl, Growth ~1490 zl z biala etykieta wliczona w cenie, Enterprise wycena
// indywidualna). Ten sam wzorzec izolacji co BlogPage.jsx/GapAssessmentLandingPage.jsx.
// 11.08: strona pilotazowa dla PL/EN + jasny/ciemny na calej stronie publicznej (patrz plan
// luminous-dazzling-pumpkin.md) - pierwszy plik z pelnym wzorcem, kopiowanym pozniej na reszte.

const FONT_FACES = `
@font-face{font-family:'Oswald';src:url('/fonts/oswald-400-latin-ext.woff2') format('woff2');font-weight:400;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-400-latin.woff2') format('woff2');font-weight:400;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-500-latin-ext.woff2') format('woff2');font-weight:500;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-500-latin.woff2') format('woff2');font-weight:500;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-600-latin-ext.woff2') format('woff2');font-weight:600;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-600-latin.woff2') format('woff2');font-weight:600;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-700-latin-ext.woff2') format('woff2');font-weight:700;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-700-latin.woff2') format('woff2');font-weight:700;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Roboto Mono';src:url('/fonts/robotomono-400-latin-ext.woff2') format('woff2');font-weight:400;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Roboto Mono';src:url('/fonts/robotomono-400-latin.woff2') format('woff2');font-weight:400;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Roboto Mono';src:url('/fonts/robotomono-500-latin-ext.woff2') format('woff2');font-weight:500;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Roboto Mono';src:url('/fonts/robotomono-500-latin.woff2') format('woff2');font-weight:500;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Roboto Mono';src:url('/fonts/robotomono-700-latin-ext.woff2') format('woff2');font-weight:700;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Roboto Mono';src:url('/fonts/robotomono-700-latin.woff2') format('woff2');font-weight:700;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
`;

const PAGE_CSS = `
.galp{
  --paper:#E7E8E3; --paper-raised:#F8F9F6; --panel2:#DEE1DA; --ink:#1B2124; --ink-soft:#5C6569;
  --line:#C6CAC2; --line-soft:#D9DCD5;
  --accent:#1E7A46; --accent-ink:#FFFFFF; --accent-soft:#DCEEE2;
  --amber:#9C6A16; --amber-soft:#F3E4C8;
  --red:#B93A2C; --red-soft:#F3DCD4;
  --panelA:#F8F9F6; --panelB:#E4E6E0;
  --shadow:0 1px 2px rgba(20,30,25,.05), 0 8px 20px -12px rgba(20,30,25,.14);
  background:var(--paper); color:var(--ink); font-family:'Oswald',system-ui,sans-serif; font-weight:500; font-size:16px; line-height:1.6; -webkit-font-smoothing:antialiased;
}
/* Ciemny motyw (11.08) - blok dodatkowy wewnatrz TEGO SAMEGO wbudowanego <style>, nigdy wspolny
   plik CSS (patrz plan - izolacja per-strona jest swiadoma, chronila juz raz przed bugiem wyscigu
   react-snap). data-theme siedzi na <html> (ThemeContext.jsx), wiec selektor potomka dziala
   niezaleznie od tego ktora leniwie-ladowana strona jest akurat zamontowana. */
[data-theme='dark'] .galp{
  --paper:#15181A; --paper-raised:#1E2225; --panel2:#262B27; --ink:#E9EAE4; --ink-soft:#8B948F;
  --line:#33383A; --line-soft:#282C2E;
  --accent:#3CB878; --accent-ink:#0B1712; --accent-soft:#1B2E22;
  --amber:#D79A3C; --amber-soft:#332A18;
  --red:#E2604C; --red-soft:#3A211D;
  --panelA:#2A2E30; --panelB:#1B1E20;
  --shadow:0 1px 2px rgba(0,0,0,.4), 0 10px 24px -12px rgba(0,0,0,.55);
}
.galp *{box-sizing:border-box;}
.galp h1,.galp h2,.galp h3,.galp h4{margin:0; font-weight:600; text-transform:uppercase; letter-spacing:.02em; text-wrap:balance; color:var(--ink);}
.galp p{margin:0 0 1em; max-width:65ch; color:var(--ink-soft);}
.galp p:last-child{margin-bottom:0;}
.galp a{color:var(--accent); text-decoration:none;}
.galp :focus-visible{outline:2px solid var(--accent); outline-offset:2px;}
.galp .wrap{max-width:1100px; margin:0 auto; padding:0 24px;}
.galp section{padding:68px 0;}
.galp .eyebrow{font-family:'Roboto Mono',monospace; font-size:.72rem; font-weight:500; text-transform:uppercase; letter-spacing:.18em; color:var(--accent); display:inline-flex; align-items:center; gap:9px; margin-bottom:16px;}
.galp .eyebrow::before{content:''; width:6px; height:6px; border-radius:50%; background:var(--accent);}

.galp .topbar{display:flex; align-items:center; justify-content:space-between; gap:16px; padding:16px 0; border-bottom:1px solid var(--line);}
.galp .brand{display:flex; align-items:center; gap:10px; font-weight:700; font-size:.95rem; text-transform:uppercase; letter-spacing:.05em;}
.galp .brand .sq{width:17px; height:17px; background:var(--accent); border-radius:3px;}
.galp .brand small{font-weight:500; color:var(--ink-soft); letter-spacing:.1em; font-size:.68rem;}
.galp .navlinks{display:flex; align-items:center; gap:22px; margin-right:auto; margin-left:32px;}
.galp .navlinks a{font-size:.82rem; font-weight:600; color:var(--ink-soft); text-decoration:none; text-transform:uppercase; letter-spacing:.04em;}
.galp .navlinks a:hover{color:var(--accent);}
.galp .toggles{flex:none;}
.galp .hamburger{display:none; background:none; border:none; cursor:pointer; padding:8px; flex:none;}
.galp .hamburger span{display:block; width:22px; height:2px; background:var(--ink); margin:5px 0;}
.galp .mobile-menu{display:none; flex-direction:column; padding:6px 0 14px; border-bottom:1px solid var(--line);}
.galp .mobile-menu.open{display:flex;}
.galp .mobile-menu a.mlink{padding:13px 4px; font-size:.9rem; font-weight:600; color:var(--ink); text-decoration:none; text-transform:uppercase; letter-spacing:.03em; border-bottom:1px solid var(--line-soft);}
.galp .mobile-menu .btn{margin-top:12px; justify-content:center;}
.galp .mobile-menu .toggles{margin-top:12px; justify-content:center; display:flex;}
/* !important konieczny (11.08) - PublicToggleBar.jsx ustawia display:flex jako inline style (React
   style={{...}}), ktory zawsze wygrywa z reguly arkusza zewnetrznego niezaleznie od specyficznosci -
   to jedyny sposob zeby ta reguza-media-query mogla go schowac na mobile. */
@media (max-width:600px){ .galp .navlinks{display:none;} .galp .topbar .toggles{display:none !important;} .galp .hamburger{display:block;} }

.galp .btn{font-family:'Oswald',sans-serif; font-size:.82rem; font-weight:600; text-transform:uppercase; letter-spacing:.05em; padding:11px 22px; border-radius:5px; border:1px solid var(--line); color:var(--ink); background:var(--paper-raised); display:inline-flex; align-items:center; gap:8px; cursor:pointer; transition:border-color .15s, transform .1s; text-decoration:none;}
.galp .btn:hover{border-color:var(--ink-soft);}
.galp .btn.pri{background:var(--accent); color:var(--accent-ink); border-color:var(--accent); box-shadow:var(--shadow);}
.galp .btn.big{padding:14px 28px; font-size:.86rem;}
.galp .btn.block{width:100%; justify-content:center;}

.galp .pricehero{padding:56px 0 12px; text-align:center;}
.galp .pricehero .eyebrow{justify-content:center;}
.galp .pricehero h1{font-size:clamp(1.7rem,3.6vw,2.3rem); line-height:1.15; margin:0 auto 14px; max-width:20ch;}
.galp .pricehero p{font-size:1rem; margin:0 auto; max-width:52ch;}

.galp .plans{display:grid; grid-template-columns:repeat(4,1fr); gap:16px; align-items:stretch;}
.galp .plan{background:var(--paper-raised); border:1px solid var(--line); border-radius:13px; padding:30px 26px; display:flex; flex-direction:column; position:relative;}
.galp .plan.reco{border-color:var(--accent); box-shadow:0 0 0 1px var(--accent), var(--shadow);}
.galp .plan .badge{position:absolute; top:-12px; left:26px; background:var(--accent); color:var(--accent-ink); font-family:'Roboto Mono',monospace; font-size:.62rem; font-weight:700; text-transform:uppercase; letter-spacing:.08em; padding:4px 11px; border-radius:100px;}
.galp .plan .pname{font-size:1.05rem; margin-bottom:6px;}
.galp .plan .pdesc{font-size:.82rem; margin-bottom:20px; min-height:2.6em;}
.galp .plan .price{display:flex; align-items:baseline; gap:6px; margin-bottom:4px; font-family:'Roboto Mono',monospace;}
.galp .plan .price .num{font-size:2.1rem; font-weight:700; color:var(--ink); letter-spacing:-.01em;}
.galp .plan .price .unit{font-size:.78rem; color:var(--ink-soft);}
.galp .plan .pricenote{font-size:.72rem; color:var(--ink-soft); margin-bottom:22px; font-family:'Roboto Mono',monospace;}
.galp .plan ul{list-style:none; margin:0 0 24px; padding:0; display:flex; flex-direction:column; gap:10px; flex:1;}
.galp .plan li{font-size:.85rem; color:var(--ink); display:flex; gap:9px; align-items:flex-start;}
.galp .plan li::before{content:'✓'; color:var(--accent); font-weight:700; flex:none; margin-top:1px;}
.galp .plan li.muted{color:var(--ink-soft);}
.galp .plan li.muted::before{content:'-'; color:var(--line);}
@media (max-width:1050px){.galp .plans{grid-template-columns:1fr 1fr;}}
@media (max-width:640px){.galp .plans{grid-template-columns:1fr;}}

/* Modal potwierdzenia zakupu (13.08, na miejsce checkboxa nad kartami planow - Marcin: "w tym
   miejscu jest szpetne" + "nic nie mowi nikomu o niczym") - zgoda 14-dniowa pojawia sie teraz
   dopiero w momencie realnej decyzji o zakupie konkretnego planu, nie wczesniej przy samym
   przegladaniu cennika, i jest faktycznie zapisywana po stronie backendu (patrz goBuy/confirmBuy). */
.galp .confirmoverlay{position:fixed; inset:0; background:rgba(10,14,12,.55); z-index:300; display:flex; align-items:center; justify-content:center; padding:20px;}
.galp .confirmcard{background:var(--paper-raised); border:1px solid var(--line); border-radius:14px; padding:28px; max-width:440px; width:100%; box-shadow:var(--shadow);}
.galp .confirmcard h3{font-size:1.05rem; margin-bottom:4px;}
.galp .confirmcard .cprice{font-family:'Roboto Mono',monospace; font-size:.85rem; color:var(--ink-soft); margin-bottom:18px;}
.galp .confirmcard .consent{display:flex; align-items:flex-start; gap:9px; font-size:.8rem; color:var(--ink-soft); margin-bottom:22px; cursor:pointer; max-width:70ch;}
.galp .confirmcard .consent input{margin-top:3px; flex:none;}
.galp .confirmcard .cbtns{display:flex; gap:10px; justify-content:flex-end;}

.galp .faq{margin-top:56px;}
.galp .faq details{border-bottom:1px solid var(--line); padding:18px 0;}
.galp .faq summary{cursor:pointer; font-weight:600; font-size:.92rem; list-style:none; display:flex; justify-content:space-between; gap:16px; color:var(--ink);}
.galp .faq summary::-webkit-details-marker{display:none;}
.galp .faq summary::after{content:'+'; font-family:'Roboto Mono',monospace; color:var(--accent); flex:none;}
.galp .faq details[open] summary::after{content:'-';}
.galp .faq p{margin-top:12px; font-size:.85rem;}

.galp .ctaband{margin-top:60px; text-align:center; padding:44px 32px; background:var(--ink); border-radius:16px;}
.galp .ctaband h2{color:#fff; font-size:1.3rem; margin-bottom:10px;}
.galp .ctaband p{color:#B7BEB9; margin:0 auto 22px; max-width:46ch;}
/* --ink to jasny kolor w ciemnym motywie (odwrocona rola) - .ctaband uzywa go tu jako "zawsze
   ciemna wstega" w jasnym motywie, wiec w ciemnym potrzebuje wlasnego, jawnego overrida zamiast
   dziedziczyc token, inaczej wstega staje sie jasna z niewidocznym bialym tekstem na wierzchu. */
[data-theme='dark'] .galp .ctaband{background:var(--paper-raised); border:1px solid var(--line);}
[data-theme='dark'] .galp .ctaband h2{color:var(--ink);}
[data-theme='dark'] .galp .ctaband p{color:var(--ink-soft);}

.galp footer{border-top:1px solid var(--line); padding:24px 0 38px; display:flex; justify-content:space-between; gap:16px; flex-wrap:wrap; font-family:'Roboto Mono',monospace; font-size:.72rem; color:var(--ink-soft);}
.galp footer .legal{display:flex; gap:16px;}
.galp footer .legal a{color:var(--ink-soft); text-decoration:none;}
.galp footer .legal a:hover{color:var(--accent);}

@media (max-width:600px){ .galp section{padding:48px 0;} }
`;

const PLANS = [
  {
    key: 'trial', name: 'Trial', desc: 'Sprawdź platformę na własnym portfelu, zanim zdecydujesz.',
    price: '0', unit: 'zł', note: 'bez karty płatniczej',
    features: [
      'Do 3 klientów w portfelu',
      'Do 10 analiz Gap Audit',
      'Wszystkie 13 norm w bibliotece',
      'Bez limitu czasowego',
    ],
    mutedFeatures: ['Biała etykieta (własna marka)', 'Panel wielu audytorów w zespole'],
    cta: 'Załóż konto i wypróbuj', action: 'trial',
  },
  {
    key: 'starter', name: 'Starter', desc: 'Dla konsultanta pracującego z pierwszymi płacącymi klientami.',
    price: '490', unit: 'zł / mies.', note: 'do 10 klientów w portfelu',
    features: [
      'Wszystkie 13 norm w bibliotece',
      'Nielimitowane analizy Gap Audit',
      'Dziennik aktywności i historia rewizji',
      'Eksport raportów PDF',
    ],
    mutedFeatures: ['Biała etykieta (własna marka)', 'Panel wielu audytorów w zespole'],
    cta: 'Zacznij teraz', action: 'buy',
  },
  {
    key: 'growth', name: 'Growth', desc: 'Dla firmy konsultingowej z rosnącym portfelem i własną marką.', reco: true,
    price: '1490', unit: 'zł / mies.', note: 'bez limitu klientów w portfelu',
    features: [
      'Wszystko z pakietu Starter',
      'Biała etykieta wliczona w cenie',
      'Do 5 kont audytorów w zespole',
      'Priorytetowe wsparcie',
    ],
    mutedFeatures: [],
    cta: 'Zacznij teraz', action: 'buy',
  },
  {
    key: 'enterprise', name: 'Enterprise', desc: 'Dla organizacji z niestandardowymi wymaganiami integracyjnymi.',
    price: 'Wycena', unit: 'indywidualna', note: 'ustalana po rozmowie',
    features: [
      'Wszystko z pakietu Growth',
      'Nielimitowane konta audytorów',
      'Integracje i wdrożenie dedykowane',
      'Opiekun wdrożenia',
    ],
    mutedFeatures: [],
    cta: 'Umów rozmowę', action: 'demo',
  },
];

// EN mirror (11.08) - ten sam wzorzec co SECTIONS/SECTIONS_EN w TermsPage.jsx/PrivacyPage.jsx.
// price/unit dla trial/starter/growth zostaje w PLN (realna waluta rozliczenia, nie tlumaczona).
const PLANS_EN = [
  {
    key: 'trial', name: 'Trial', desc: 'Try the platform on your own portfolio before you decide.',
    price: '0', unit: 'zł', note: 'no payment card required',
    features: [
      'Up to 3 clients in your portfolio',
      'Up to 10 Gap Audit analyses',
      'All 13 standards in the library',
      'No time limit',
    ],
    mutedFeatures: ['White-label (your own brand)', 'Multi-auditor team panel'],
    cta: 'Create an account and try it', action: 'trial',
  },
  {
    key: 'starter', name: 'Starter', desc: 'For consultants working with their first paying clients.',
    price: '490', unit: 'zł / mo', note: 'up to 10 clients in your portfolio',
    features: [
      'All 13 standards in the library',
      'Unlimited Gap Audit analyses',
      'Activity log and revision history',
      'PDF report export',
    ],
    mutedFeatures: ['White-label (your own brand)', 'Multi-auditor team panel'],
    cta: 'Start now', action: 'buy',
  },
  {
    key: 'growth', name: 'Growth', desc: 'For consulting firms with a growing portfolio and their own brand.', reco: true,
    price: '1490', unit: 'zł / mo', note: 'no limit on clients in your portfolio',
    features: [
      'Everything in Starter',
      'White-label included in the price',
      'Up to 5 auditor accounts on your team',
      'Priority support',
    ],
    mutedFeatures: [],
    cta: 'Start now', action: 'buy',
  },
  {
    key: 'enterprise', name: 'Enterprise', desc: 'For organizations with custom integration requirements.',
    price: 'Custom', unit: 'pricing', note: 'set after a call',
    features: [
      'Everything in Growth',
      'Unlimited auditor accounts',
      'Custom integrations and rollout',
      'Dedicated onboarding manager',
    ],
    mutedFeatures: [],
    cta: 'Book a call', action: 'demo',
  },
];

const FAQ = [
  { q: 'Czy mogę przetestować platformę przed zakupem?', a: 'Tak - konto testowe zakładasz samodzielnie w kilka minut i masz dostęp do realnego zakresu portfela, analiz i wszystkich 13 norm, bez podawania danych karty.' },
  { q: 'Co dokładnie oznacza biała etykieta w pakiecie Growth?', a: 'Twoi klienci logują się i widzą raporty pod Twoją marką - Twoje logo, Twoje kolory, Twoja domena. Gap Assessment działa w tle jako silnik analizy.' },
  { q: 'Czy mogę zmienić pakiet w trakcie korzystania?', a: 'Tak, przejście między pakietami jest dostępne z poziomu konta w dowolnym momencie, bez utraty historii analiz i klientów.' },
  { q: 'Co się dzieje z danymi klientów, jeśli zrezygnuję?', a: 'Dane pozostają dostępne do eksportu przez 30 dni po zakończeniu subskrypcji, zgodnie z zasadami opisanymi w Regulaminie i Polityce prywatności.' },
];

// Tresc zgody 14-dniowej (13.08) - patrz TermsPage.jsx 6.4, ten sam wzorzec prawny. Backend NIE
// przyjmuje tej tresci z frontendu (patrz confirmBuy/payu.js) - wysylamy tylko flage+jezyk, backend
// znakuje zapis wlasna, stala wersja (CONSENT_VERSION), zeby dowod zgody nie dal sie sfalszowac
// dowolnym tekstem wyslanym w requescie.
const CONSENT_TEXT_PL = 'Wiem, że dostęp do planu Starter/Growth aktywuje się natychmiast po płatności i zgadzam się na rozpoczęcie świadczenia usługi cyfrowej przed upływem 14-dniowego terminu odstąpienia od umowy. Rozumiem, że zgodnie z art. 38 pkt 13 ustawy o prawach konsumenta oznacza to utratę prawa do odstąpienia od umowy i zwrotu płatności.';
const CONSENT_TEXT_EN = 'I understand that Starter/Growth plan access activates immediately after payment, and I agree to the digital service starting before the 14-day withdrawal period expires. I understand that, under Article 38(13) of the Polish Consumer Rights Act, this means I lose the right to withdraw from the contract and receive a refund.';

const FAQ_EN = [
  { q: 'Can I try the platform before buying?', a: 'Yes. You create a trial account yourself in a few minutes and get real access to the portfolio, analyses and all 13 standards, with no card details required.' },
  { q: 'What exactly does white-label mean in the Growth plan?', a: 'Your clients log in and see reports under your own brand: your logo, your colors, your domain. Gap Assessment runs in the background as the analysis engine.' },
  { q: 'Can I change plans while using the platform?', a: 'Yes, switching between plans is available from your account at any time, without losing your analysis history or clients.' },
  { q: 'What happens to client data if I cancel?', a: 'Data remains available for export for 30 days after your subscription ends, per the terms described in the Terms of Service and Privacy Policy.' },
];

export default function CennikPage() {
  const navigate = useNavigate();
  const rootRef = useRef(null);
  const { lang } = useLang();
  const e = lang === 'en';
  const plans = e ? PLANS_EN : PLANS;
  const faq = e ? FAQ_EN : FAQ;
  // 11.08: ?tab=register otwiera LoginView od razu na zakladce zakladania nowej firmy (patrz
  // LoginView.jsx/GapMvp.jsx) - intencja klikniecia "Zacznij teraz" na cenniku to zawsze rejestracja,
  // nie logowanie, wiec nie zmuszamy do dodatkowego klikniecia zakladki.
  const goTrial = (ev) => { ev.preventDefault(); navigate('/app?tab=register'); };
  const goDemo = (ev) => { ev.preventDefault(); navigate('/#kontakt'); };
  const [menuOpen, setMenuOpen] = useState(false);
  const [buying, setBuying] = useState(false); // 11.08 (przeglad kodu): blokada podwojnego klikniecia
  // Modal potwierdzenia zakupu (13.08, patrz komentarz przy CONSENT_TEXT_PL wyzej) - confirmPlan
  // trzyma caly obiekt planu (null = modal zamkniety), modalConsent to stan checkboxa WEWNATRZ modala.
  const [confirmPlan, setConfirmPlan] = useState(null);
  const [modalConsent, setModalConsent] = useState(false);

  const openBuyModal = (ev, plan) => { ev.preventDefault(); setModalConsent(false); setConfirmPlan(plan); };
  const closeBuyModal = () => { if (!buying) setConfirmPlan(null); };

  // PayU (11.08, przebudowane 13.08 na modal) - Starter/Growth maja realny checkout, w odroznieniu od
  // Trial (konto od razu) i Enterprise (kontakt). Niezalogowany klika "Potwierdz i przejdz do
  // platnosci" -> zapamietujemy wybrany plan+zgode (z znacznikiem czasu, patrz AppShell.jsx) i po
  // zalogowaniu/rejestracji w /app checkout odpala sie automatycznie.
  const confirmBuy = async () => {
    if (!confirmPlan || !modalConsent || buying) return;
    const planKey = confirmPlan.key;
    if (!getToken()) {
      sessionStorage.setItem('gap_pending_checkout_plan', JSON.stringify({ plan: planKey, ts: Date.now(), consent: true, consentLang: lang }));
      setConfirmPlan(null);
      navigate('/app?tab=register');
      return;
    }
    setBuying(true);
    try {
      const data = await api('/payu/checkout', { method: 'POST', body: JSON.stringify({ plan: planKey, consent: true, consentLang: lang }) });
      if (data.url) window.location.href = data.url;
      else setBuying(false);
    } catch (err) {
      alert(err.message || (e ? 'Could not start the payment. Please try again.' : 'Nie udalo sie rozpoczac platnosci. Sprobuj ponownie.'));
      setBuying(false);
    }
  };
  return (
    <div className="galp" ref={rootRef}>
      <style>{FONT_FACES}</style>
      <style>{PAGE_CSS}</style>
      <Helmet>
        <title>{e ? 'Pricing | Gap Assessment by MQS' : 'Cennik | Gap Assessment by MQS'}</title>
        <meta name="description" content={e
          ? 'Gap Assessment by MQS plans: Starter 490 PLN/mo, Growth 1490 PLN/mo with white-label included, Enterprise custom pricing.'
          : 'Pakiety Gap Assessment by MQS: Starter 490 zł/mies., Growth 1490 zł/mies. z białą etykietą w cenie, Enterprise wycena indywidualna.'} />
      </Helmet>
      <header className="wrap">
        <div className="topbar">
          <a className="brand" onClick={(ev) => { ev.preventDefault(); navigate('/'); }} href="/" style={{ textDecoration: 'none', color: 'inherit' }}><span className="sq"></span>Gap Assessment <small>by MQS</small></a>
          <nav className="navlinks">
            <a onClick={(ev) => { ev.preventDefault(); navigate('/blog'); }} href="/blog">Blog</a>
          </nav>
          <PublicToggleBar style={{ marginLeft: 'auto' }} className="toggles" />
          <a className="btn pri topcta" onClick={goTrial} href="/app?tab=register">{e ? 'Create an account and try it' : 'Załóż konto i wypróbuj'}</a>
          <button type="button" className="hamburger" aria-label="Menu" aria-expanded={menuOpen} onClick={() => setMenuOpen(v => !v)}>
            <span></span><span></span><span></span>
          </button>
        </div>
        <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
          <a className="mlink" onClick={(ev) => { ev.preventDefault(); navigate('/'); }} href="/">{e ? 'Home' : 'Strona główna'}</a>
          <a className="mlink" onClick={(ev) => { ev.preventDefault(); navigate('/blog'); }} href="/blog">Blog</a>
          <div className="toggles"><PublicToggleBar /></div>
          <a className="btn pri" onClick={goTrial} href="/app?tab=register">{e ? 'Create an account and try it' : 'Załóż konto i wypróbuj'}</a>
        </div>
      </header>
      <div className="wrap">
        <section className="pricehero">
          <div className="eyebrow">{e ? 'Pricing' : 'Cennik'}</div>
          <h1>{e ? 'One subscription for your entire client portfolio' : 'Jeden abonament na cały portfel klientów'}</h1>
          <p>{e
            ? 'No per-analysis fees and no per-client surcharges on the Growth and Enterprise plans. Start with a trial account, move to a paid plan when your portfolio needs it.'
            : 'Bez opłat za pojedynczą analizę i bez dopłat za kolejnego klienta w pakietach Growth i Enterprise. Zaczynasz od konta testowego, przechodzisz na płatny pakiet, kiedy portfel tego wymaga.'}</p>
          <p style={{ fontSize: '.86rem' }}>{e ? "Not sure yet if it's for you? " : 'Nie wiesz jeszcze, czy to dla Ciebie? '}
            <a onClick={(ev) => { ev.preventDefault(); navigate('/przyklad-raportu'); }} href="/przyklad-raportu">{e ? 'See a sample report' : 'Zobacz przykładowy raport'}</a>
            {e ? ' before creating an account.' : ' zanim założysz konto.'}</p>
        </section>
        <section style={{ paddingTop: 0 }}>
          <div className="plans">
            {plans.map((p) => (
              <div className={`plan${p.reco ? ' reco' : ''}`} key={p.key}>
                {p.reco && <span className="badge">{e ? 'Most popular' : 'Najczęściej wybierany'}</span>}
                <h3 className="pname">{p.name}</h3>
                <div className="pdesc">{p.desc}</div>
                <div className="price"><span className="num">{p.price}</span><span className="unit">{p.unit}</span></div>
                <div className="pricenote">{p.note}</div>
                <ul>
                  {p.features.map((f, i) => <li key={i}>{f}</li>)}
                  {p.mutedFeatures.map((f, i) => <li className="muted" key={`m${i}`}>{f}</li>)}
                </ul>
                {p.action === 'demo'
                  ? <a className="btn block" onClick={goDemo} href="/#kontakt">{p.cta}</a>
                  : p.action === 'buy'
                    ? <a className="btn pri block" onClick={(ev) => openBuyModal(ev, p)} href="/app?tab=register">{p.cta}</a>
                    : <a className="btn pri block" onClick={goTrial} href="/app?tab=register">{p.cta}</a>}
              </div>
            ))}
          </div>

          <div className="faq">
            <h2 style={{ marginBottom: 20 }}>{e ? 'Frequently asked questions' : 'Najczęściej zadawane pytania'}</h2>
            {faq.map((f, i) => (
              <details key={i}>
                <summary>{f.q}</summary>
                <p>{f.a}</p>
              </details>
            ))}
          </div>

          <div className="ctaband">
            <h2>{e ? 'Prefer to see the platform live?' : 'Wolisz zobaczyć platformę na żywo?'}</h2>
            <p>{e
              ? "We'll set up a 20-minute walkthrough on your own portfolio and answer your rollout questions."
              : 'Umówimy 20-minutową prezentację na Twoim portfelu i odpowiemy na pytania dotyczące wdrożenia.'}</p>
            <a className="btn pri big" onClick={goDemo} href="/#kontakt">{e ? 'Book a demo' : 'Umów prezentację'}</a>
          </div>
        </section>
      </div>
      <footer className="wrap">
        <span>Gap Assessment by MQS</span>
        <span>{e ? 'ISO compliance audits for consultants · 13 standards · white-label' : 'Audyt zgodności ISO dla konsultantów · 13 norm · white-label'}</span>
        <span className="legal">
          <a onClick={(ev) => { ev.preventDefault(); navigate('/'); }} href="/">{e ? 'Home' : 'Strona główna'}</a>
          <a onClick={(ev) => { ev.preventDefault(); navigate('/blog'); }} href="/blog">Blog</a>
          <a href="/polityka-prywatnosci">{e ? 'Privacy Policy' : 'Polityka prywatności'}</a>
          <a href="/regulamin">{e ? 'Terms of Service' : 'Regulamin'}</a>
        </span>
      </footer>
      {confirmPlan && (
        <div className="confirmoverlay" onClick={closeBuyModal}>
          <div className="confirmcard" onClick={(ev) => ev.stopPropagation()}>
            <h3>{confirmPlan.name}</h3>
            <div className="cprice">{confirmPlan.price} {confirmPlan.unit}</div>
            <label className="consent">
              <input type="checkbox" checked={modalConsent} onChange={(ev) => setModalConsent(ev.target.checked)} autoFocus />
              <span>{e ? CONSENT_TEXT_EN : CONSENT_TEXT_PL}</span>
            </label>
            <div className="cbtns">
              <button type="button" className="btn" onClick={closeBuyModal} disabled={buying}>{e ? 'Cancel' : 'Anuluj'}</button>
              <button
                type="button" className="btn pri" onClick={confirmBuy} disabled={!modalConsent || buying}
                style={(!modalConsent || buying) ? { opacity: .6, cursor: 'not-allowed' } : undefined}
              >
                {buying ? (e ? 'Processing…' : 'Przetwarzam…') : (e ? 'Confirm and pay' : 'Potwierdź i przejdź do płatności')}
              </button>
            </div>
          </div>
        </div>
      )}
      <PrerenderReady />
    </div>
  );
}
